'use client';
import type React from 'react';

import { useHeaderContext } from '~widgets/Header/context';

import { StyledHeader } from './styles';

type Props = {
	children: React.ReactNode;
};

export const Wrapper = ({ children }: Props) => {
	const { headerRef } = useHeaderContext();

	return <StyledHeader ref={headerRef}>{children}</StyledHeader>;
};
